import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { Text } from '@omilia/typography';
import { colors } from '@omilia/theme';

import Button from 'components/Button';
import EmptyView from 'components/EmptyView';

const SEmptyListIcon = styled.i.attrs({
  className: 'icon-thumbnail-empty-list',
})`
  display: flex;
  justify-content: center;
  color: ${colors.COLOR_GREY_600};
  font-size: 64px;
`;

const SEmptyText = styled(Text)`
  color: ${colors.COLOR_GREY_1000};
`;

const SSuggestionText = styled(Text)`
  color: ${colors.COLOR_GREY_600};
`;

interface Props {
  onCreateFileClick: () => void;
  onCreateFolderClick: () => void;
}

const SEmptyView = styled(EmptyView)`
  &&& {
    height: calc(100vh - 160px);
  }
`;

function EmptyTreeView({ onCreateFileClick, onCreateFolderClick }: Props) {
  return (
    <SEmptyView>
      <SEmptyListIcon />

      <SEmptyText level={1}>You have no files</SEmptyText>

      <SSuggestionText level={2}>
        Please create a new{' '}
        <Button isLink data-test="add-file" onClick={onCreateFileClick}>
          File
        </Button>{' '}
        or{' '}
        <Button isLink data-test="add-folder" onClick={onCreateFolderClick}>
          Folder
        </Button>
      </SSuggestionText>
    </SEmptyView>
  );
}

EmptyTreeView.propTypes = {
  onCreateFileClick: PropTypes.func.isRequired,
  onCreateFolderClick: PropTypes.func.isRequired,
};

export default EmptyTreeView;
